<section class="content">
    <div class="card" style="padding:25px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                {{title}}
            </div>
        </div>
    </div>
    <mat-accordion>
        <mat-expansion-panel *ngFor="let product_group of by_product_group_list">
            <mat-expansion-panel-header style="padding: 30px;">
                <mat-panel-title>
                    {{product_group['name']}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <table class="table table-bordered table-hovered">
                <thead>
                    <tr>
                        <th class="table-width">S. No</th>
                        <th class="table-width">Product Name</th>
                        <th class="table-width">Available Quantity</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody *ngFor="let product of by_product_dict[product_group['id']]; let product_index=index">
                    <tr>
                        <td class="table-width">{{product_index + 1}}</td>
                        <td class="table-width">{{product['short_name']}}</td>
                        <td class="table-width">{{product['quantity_now']}}</td>
                        <td>
                            <span *ngIf="!product['is_editable']">
                                <button class="mat-button" style="background: #c5ec88;border-radius: 10px;"
                                    (click)="changeToAddProduct(product_group['id'], product_index)">Add More +</button>
                            </span>
                            <span *ngIf="product['is_editable']">
                                <div class="row">
                                    <div class="col">
                                        <label>Bill Number</label>
                                        <input type="text"
                                            [(ngModel)]="by_product_dict[product_group['id']][product_index]['bill_number']"
                                            style="border: 1px solid; border-radius: 10px; text-align: center;" />
                                    </div>
                                    <div class="col">
                                        <label>Expiry Date</label>
                                        <input type="date"
                                            [(ngModel)]="by_product_dict[product_group['id']][product_index]['expiry_date']"
                                            style="border: 1px solid; border-radius: 10px; text-align: center;" />
                                    </div>
                                    <div class="col">
                                        <label>New Qty</label>
                                        <input type="number"
                                            [(ngModel)]="by_product_dict[product_group['id']][product_index]['new_quantity']"
                                            style="border: 1px solid; border-radius: 10px; text-align: center;" />
                                    </div>
                                    <div class="col" style="margin-top: 4%;">
                                        <label style="font-size: 17px;color: #ef9208;">Total :
                                            {{addNewAndOldQty(product_group['id'], product_index)}}</label>
                                    </div>
                                    <div class="col" style="margin-top: 4%;">
                                        <button class="mat-button"
                                            (click)="updateCalled(product['id'], by_product_dict[product_group['id']][product_index]['new_quantity'], by_product_dict[product_group['id']][product_index]['bill_number'], by_product_dict[product_group['id']][product_index]['expiry_date'])"
                                            [disabled]="checkValidForUpdate(product_group['id'], product_index)"
                                            style="background: #3cad3c;border-radius: 10px;">Add +</button>
                                    </div>
                                    <div class="col" style="margin-top: 4%;">
                                        <button class="mat-button" style="background: #ec9191;border-radius: 10px;"
                                            (click)="changeToAddProduct(product_group['id'], product_index)">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>
    </mat-accordion>
</section>